<section class="container steps-container">
  <octo-breadcrumb [isUberConnected$]="isUberConnected$"></octo-breadcrumb>
  <section class="step-content">

    <header class="d-flex justify-content-center">
      <img
        class="step-icon"
        src="/assets/images/proof-icon.png"
        alt="Profile icon"
        />
      <h1 class="step-heading">Uber Connect Required</h1>
    </header>
    <p class="mt-4">
      <span class="bold-text">Action Required:</span> Connect Your Uber Account to Continue Your Application
    </p>
    <br>
      <p>
        Thank you for your interest in partnering with us!
      </p>
      <br>
        <p>
          We’re reaching out to let you know that your application is currently <span class="bold-text">
        on hold</span>. To move forward with your review and become eligible for a tablet, you’ll need to
        <span class="bold-text">connect your Uber account</span>.</p>
        <p>
          Connecting your Uber account allows us to
          quickly verify your driving history and expedite your application process.
        </p>
        <br>
          <p class="bold-text">
            👉 Please complete this step as soon as possible to avoid delays.
          </p>
          <br>

            @if (uberConnectFlag && hasData) {
              <uber-connect-button
                [isHideSuccess]=true
                [uberConnectStatus]="uberConnectStatus || ''"
                [showAlreadyConnected]="isUberConnected$ | async"
                [connectedAccountPhone]="user?.journey_tv?.matched_identifier || user?.uber_connect_info?.phone_number || ''"
                [loggedUserEmailDomain]="user?.email?.split('@').pop()?.toLowerCase() || ''"
                [isReferredByUberPartner]="isReferredByUberPartner$ | async"
                >
              </uber-connect-button>
            }
          </section>
        </section>

